import { useConnectivity } from "@/hooks/useConnectivity";

// Sprint 35.0 — Indicador de estado global (Terminal y Valet).
//  🟢 EN VIVO         → conectado y sin pendientes locales
//  🟠 SINCRONIZANDO   → enviando datos locales al servidor (o con pendientes por enviar)
//  🔴 OFFLINE (X)     → sin red; X = tickets/transacciones guardados localmente
export function ConnectionStatus({ className = "" }) {
  const { status, pending } = useConnectivity();

  const cfg = {
    live: { dot: "bg-[#10B981] shadow-[0_0_8px_#10B981]", pulse: "animate-pulse", label: "EN VIVO", text: "text-[#10B981]" },
    syncing: { dot: "bg-[#F59E0B] shadow-[0_0_8px_#F59E0B]", pulse: "animate-pulse", label: "SINCRONIZANDO", text: "text-[#F59E0B]" },
    offline: { dot: "bg-[#EF4444] shadow-[0_0_8px_#EF4444]", pulse: "animate-pulse", label: `OFFLINE (${pending})`, text: "text-[#EF4444]" },
  }[status];

  return (
    <div
      className={`flex items-center gap-1.5 ${className}`}
      data-testid="connection-status"
      data-state={status}
      data-pending={pending}
      title={
        status === "offline"
          ? `Sin conexión · ${pending} registro(s) en espera de sincronizar`
          : status === "syncing"
          ? "Sincronizando datos locales con el servidor"
          : "Conectado · datos sincronizados"
      }
    >
      <span className={`h-2.5 w-2.5 rounded-full ${cfg.dot} ${cfg.pulse}`} />
      <span className={`text-[9px] uppercase tracking-wider font-bold ${cfg.text}`}>{cfg.label}</span>
    </div>
  );
}

export default ConnectionStatus;
